import * as m from "mithril";
import './NavBar.scss'
import { ActionItemDescriptor } from "./MaterialDesignComponents";
import CustomSvgIcon from "./CustomSvgIcon";

function NavBarAction() : m.Component<{actionItem:ActionItemDescriptor, isMoreButton?:boolean}> {
    return {
        view({attrs}) {
            return m("button.ml-0", {
                class:"mmd-action-item mmd-ripple flex-shrink-0" + 
                    (attrs.isMoreButton? " navbar-dropdown-menu-btn" : ""),
                onclick: (event) => {
                    attrs.actionItem.onclick();
                }
            },
                (attrs.actionItem.label!=null) ?
                m("span", {class:""},attrs.actionItem.label) :
                (attrs.actionItem.iconType != null)?
                m(CustomSvgIcon, {
                    iconType: attrs.actionItem.iconType,
                    themeCssClass: "svg-light svg-medium"
                }
                )
                : m("span", "--")
            );
        }
    }
}

export function NavBar() : m.Component<{
    title:string,
    subtitle?:string,
    logoUrl?:string|null,
    actionItems: ActionItemDescriptor[],
    collapsedActionItems?: ActionItemDescriptor[],
    onBackPressed? : () => void,
    canBackPress?: boolean,
    onClose?:() => void,
    canClose?:boolean
}> {

    let showDropDownMenu = false;

    let toggleDropDown = (event) => {
        if(showDropDownMenu) {
            console.debug("Clicking on ", event.target.classList, event.target)        
            if (event.target.classList.contains('mmd-appbar') || event.target.classList.contains('app-area-main') || 
                event.target.classList.contains('mmd-appbar-title')) {
                    console.log("contains the required class");    
                    showDropDownMenu = false;                
                    m.redraw();             
            }
        }        
    }

    return {
        oncreate: function(vnode) {
            window.addEventListener('click', toggleDropDown)
        },
        onremove: function(vnode) {
            window.removeEventListener('click', toggleDropDown)
        },
        view(vnode) {
            let attrs = vnode.attrs;
            //let hasIconAtStart = attrs.canBackPress || attrs.canClose;

            let appBarMarginStartClass = (attrs.canBackPress || attrs.canClose)? 'pl-1' : 'pl-3'
            let appBarMarginEndClass = (vnode.attrs.collapsedActionItems && vnode.attrs.collapsedActionItems.length > 0)?
                'pr-1' : 'pr-3';

            return m("div.app-area-nav", [
                    m('div', {
                        class:`mmd-appbar d-flex flex-row align-items-center bg-primary px-1 ${appBarMarginStartClass} ${appBarMarginEndClass}`},
                        [
                            (attrs.canBackPress)?
                            m(NavBarAction, {
                                actionItem : {
                                    iconType : "back_arrow",
                                    onclick : () => {
                                        if(attrs.onBackPressed != null) {
                                            attrs.onBackPressed();
                                        } else {
                                            console.warn("onBackPressed is not defined.");
                                        }
                                    }
                                }
                            }) : null,

                            (attrs.canClose)?
                            m(NavBarAction, {
                                actionItem : {
                                    iconType : "close",
                                    onclick : () => {
                                        if(attrs.onClose != null) {
                                            attrs.onClose();
                                        } else {
                                            console.warn("onClose is not defined.");
                                        }
                                    }
                                }
                            }) : null,                            
                            
                            (attrs.logoUrl == null)?
                            m("div", {class: "flex-grow-1 mmd-appbar-title"}, 
                                attrs.title
                            ) : null,
                            
                           
                            (attrs.actionItems != null)?
                            attrs.actionItems.map(actionItem => {
                                return m(NavBarAction, {
                                    actionItem : actionItem
                                })
                            }) : null,

                            (vnode.attrs.collapsedActionItems && vnode.attrs.collapsedActionItems.length > 0)?
                            [
                                m("div", {
                                    class: (showDropDownMenu)? "more dropdown-menu-shown" : "more"
                                },
                                    m(NavBarAction, {
                                        isMoreButton: true,
                                        actionItem: {
                                            iconType:'more_vert',
                                            onclick: () => {
                                                showDropDownMenu = !showDropDownMenu;
                                            }
                                        }
                                    })
                                ),          
                                                  
                                m("div.navbar-dropdown-menu-content", 
                                    m("div.list-group", 
                                        vnode.attrs.collapsedActionItems.map(item => 
                                            m("button.list-group-item list-group-item-action", {
                                                //href:"#" + item.label,
                                                onclick: (event) => {
                                                    console.log("nav menu clicked : ", item)
                                                    event.preventDefault();
                                                    item.onclick();

                                                    showDropDownMenu = false;                
                                                    m.redraw();  
                                                }
                                            }, item.label)    
                                        )
                                        //m("a.list-group-item list-group-item-action", {href:"#"}, "Menu Item 1")
                                    )
                                )
                            ] : null                        
                        ]        
                    ),
 
                    m("div", {class: "bg-white"}, vnode.children)
                ]
            )
        }
    }
}
